import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const SEVERITY_STYLES = {
    CRITICAL: {
        backgroundColor: '#D32F2F',
        color: '#FFFFFF',
    },
    HIGH: {
        backgroundColor: '#F99C24',
        color: '#000000',
    },
    MEDIUM: {
        backgroundColor: '#0288D1',
        color: '#FFFFFF',
    },
    LOW: {
        backgroundColor: '#2E7D32',
        color: '#FFFFFF',
    },
    INFO: {
        backgroundColor: '#1976D2',
        color: '#FFFFFF',
    },
};

const DEFAULT_STYLE = SEVERITY_STYLES.HIGH;

const BannerContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'severityStyle',
})(({ severityStyle }) => ({
    display: 'flex',
    backgroundColor: `${severityStyle?.backgroundColor || DEFAULT_STYLE.backgroundColor} !important`,
    color: severityStyle?.color || DEFAULT_STYLE.color,
    // padding: '5px 24px 0 24px',
    // fontSize: '14px',
    // textAlign: 'center',
    // justifyContent: 'center',
    // width: '100%',
    // flexDirection: 'column',
    // '& a': {
    //     color: 'inherit',
    //     fontWeight: 'bold',
    // },
    // '& p': {
    //     marginTop: '10px',
    //     textAlign: 'justify',
    // },
    padding: '5px 0 0 24px',
    // fontSize: '24px',
    textAlign: 'center',
    justifyContent: 'center',
    width: '100%',
    // fontWeight: 'bold',
    flexDirection: 'column',
}));

const FreezeBanner = ({ message, severity }) => {
    const severityStyle = SEVERITY_STYLES[severity?.toUpperCase()] || DEFAULT_STYLE;

    return (
        <BannerContainer severityStyle={severityStyle} data-testid="freeze-banner">
            <p
                style={{
                    paddingRight: '24px',
                    marginTop: '10px',
                    marginBottom: '10px',
                    textAlign: 'justify',
                    maxHeight: '144px',
                    overflowY: 'auto',
                    '&::-webkit-scrollbar': { width: '6px' },
                    '&::-webkit-scrollbar-track': { background: 'transparent' },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(255,255,255,0.6)',
                        borderRadius: '3px',
                    },
                    scrollbarWidth: 'thin',
                    scrollbarColor: 'rgba(255,255,255,0.6) transparent',
                }}
            >
                <Box
                    component="span"
                    sx={{
                        fontSize: '18px',
                        // fontWeight: 500,
                        lineHeight: '28px',
                        fontFamily: 'Inter, sans-serif !important',
                    }}
                    dangerouslySetInnerHTML={{ __html: message }}
                />
            </p>
        </BannerContainer>
    );
};

FreezeBanner.propTypes = {
    message: PropTypes.string.isRequired,
    severity: PropTypes.oneOf(['CRITICAL', 'HIGH', 'MEDIUM', 'LOW', 'INFO']),
};

FreezeBanner.defaultProps = {
    severity: 'HIGH',
};

export default FreezeBanner;
